import { ResellerAgreementStatus } from '../../modules/resaleAuthorizations'

export const mappingResaleForAdmin = {
  'Reseller name': 'resellerName',
  'Labra reseller agreement ID': 'id',
  'Product name': 'productName',
  'Created at': 'createdAt',
  'AWS agreement ID': 'awsAgreementId',
  Status: 'status',
  Actions: 'actions',
}

export const mappingResaleForLabraUI = {
  'Labra Authorization ID': 'labraAuthorizationId',
  'AWS Authorization ID': 'awsAuthorizationId',
  'Product name': 'productName',
  'Reseller name': 'resellerName',
  'Authorization name': 'authorisationName',
  Status: 'status',
  'Created at': 'createdAt',
  Actions: 'actions',
}

export const statusMappingForLabraUI: Record<string, ResellerAgreementStatus> =
  {
    'In Progress': ResellerAgreementStatus.IN_PROGRESS,
    Active: ResellerAgreementStatus.ACTIVE,
    Expired: ResellerAgreementStatus.EXPIRED,
    Completed: ResellerAgreementStatus.COMPLETED,
    'Deactivation in progress':
      ResellerAgreementStatus.DEACATIVATION_IN_PROGRESS,
    Restricted: ResellerAgreementStatus.RESTRICTED,
  }
